import React, { useContext } from 'react';
import { HiOutlineMapPin, HiOutlinePencil } from 'react-icons/hi2';
import { RxInstagramLogo } from 'react-icons/rx';
import { FormattedMessage } from 'react-intl';
import { GiCutDiamond } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { BasePopupContext } from "../../../hooks/usePopup"
import { set_active_profile } from '../../../redux/slices/influencerProfileSlice';
import { FaTiktok } from 'react-icons/fa6';
import { GrInstagram } from 'react-icons/gr';
import { RiVerifiedBadgeFill } from 'react-icons/ri';
import { formatFollowers, setAgencyInfluencerProfile } from '../../../utils';
import { IoPersonOutline } from "react-icons/io5";
import { CATEGORIES } from '../../../constants';
import ToolTipText from '../../ToolTipText';


function Card({ data, }) {
    const dispatch = useDispatch();
    const {closePopup} = useContext(BasePopupContext);


    const handleChangeProfile = () => {
        dispatch(set_active_profile(data))
        setAgencyInfluencerProfile(data)
        closePopup();
    }

    return (
        // <div
        //     onClick={handleChangeProfile}
        //     className={`group flex flex-col cursor-pointer bg-white hover:bg-primary hover:text-white lg:flex-row lg:items-center gap-y-2 md:gap-y-0 mb-3  py-6 px-6 lg:px-4 rounded-2xl group shadow-md w-full
        //     }`}>
        //     <div className="flex items-center gap-x-3 flex-grow">
        //         <div className="transition-all hover:text-primary bg-primary text-white flex items-center justify-center rounded-full w-12 h-12 group-hover:bg-white bg-cover bg-no-repeat bg-center"
        //         style={{
        //             backgroundColor: `url(${data.user.picture})` 
        //         }}
        //         >
        //             {data.user.name[0]}{data.user.sur_name[0]}
        //         </div>
        //         <div className="flex flex-col gap-y-1">
        //             <h1 className={`text-xl font-bold group-hover:text-white text-t-dark `}>{data.user.name} {data.user.sur_name}</h1>
        //         </div>
        //     </div>

        //     <div className="border-l h-full py-2 px-4 border-l-gray-200 flex gap-x-2 items-center lg:items-start min-w-[200px]">
        //         <HiOutlineMapPin className={` group-hover:text-white text-primary text-2xl`} />
        //         <div className="flex flex-col text-start text-xl font-semibold">
        //             <p>{data.city}</p>
        //             <p className={`text-left text-xs font-light text-t-light  group-hover:text-white`}>
        //                 <FormattedMessage id="city" defaultMessage={"City"} />
        //             </p>
        //         </div>
        //     </div>

        //     <div className="border-l h-full py-2 px-4 border-l-gray-200 flex gap-x-2 items-center lg:items-start min-w-[200px]">
        //         <RxInstagramLogo className={` group-hover:text-white text-primary text-2xl`} />
        //         <div className="flex flex-col text-start text-xl font-semibold">
        //             <p>{data.followers}</p>
        //             <p className="text-left text-xs font-light text-t-light group-hover:text-white">
        //                 <FormattedMessage id="followers" defaultMessage={"Followers"} />
        //             </p>
        //         </div>
        //     </div>

        //     <div className="border-l h-full py-2 px-4 border-l-gray-200 flex gap-x-2 items-center lg:items-start min-w-[200px]">
        //         <GiCutDiamond className={` group-hover:text-white text-primary text-2xl`} />
        //         <div className="flex flex-col text-start text-xl font-semibold">
        //             <p>{data.engagement_rate}%</p>
        //             <p className="text-left text-xs font-light text-t-light group-hover:text-white">
        //                 <FormattedMessage id="engangement" defaultMessage={"Engagement"} />
        //             </p>
        //         </div>
        //     </div>
        // </div>
        <div 
        onClick={handleChangeProfile}
        className='w-[280px] min-h-[400px] p-4 bg-white hover:scale-[1.04] hover:transition-all hover:cursor-pointer duration-75  hover:border-primary focus:ring-2 ring-offset-4 ring-primary border-[0.5px] border-gray-200 rounded-xl shadow-lg relative  '>
                <div className='h-[270px] mb-3 flex justify-center items-center rounded-lg shadow-lg bg-cover bg-center bg-no-repeat'
                    style={{
                        backgroundImage: `url(${data?.user?.picture})`
                    }}
                >
                   {
                       !data?.user?.picture &&
                       <IoPersonOutline className='text-5xl text-primary' />
                   }
                </div>
                <div className='flex justify-between items-center'>
                    <div>
                        <h5 
                            className="mb-1 text-gray-900 flex space-x-2 items-center !line-clamp-1 "
                        >
                            {/* {data.user?.name} {data.user?.sur_name} */}
                            <ToolTipText value={data.user?.name + " " + data.user?.sur_name} />
                        </h5>
                        <p className='text-xs text-gray-500'>{data.user?.city} {data.user?.country ? `, ${data.user?.country}` : ""}</p>
                    </div>
                    <div >
                       {
                           data.instagram_followers &&
                           <div className='inline-flex space-x-1 items-center'>
                           <GrInstagram className='text-sm text-gray-500' />
                           <span>{formatFollowers(data.instagram_followers)}</span>
                       </div>
                       }
                        {
                            data.tiktok_followers &&
                            <div>
                            <div className='inline-flex space-x-1 items-center'>
                                <FaTiktok className='text-sm text-gray-500' />
                                <span>{formatFollowers(data.tiktok_followers)}</span>
                            </div>
                        </div>
                        }
                        <div className='text-xs  text-gray-500'><FormattedMessage id="followers" defaultMessage={"Followers"} /></div>
                    </div>
                </div>
                <hr className='h-[2px] border-gray-300 my-3' />

                <div className='flex justify-between items-center'>
                    <div>
                        {data.niches && data.niches?.length > 0 && (
                            <div className="flex flex-wrap gap-2">
                                {data.niches.slice(0, 2).map((niche, index) => (
                                    <span
                                        key={index}
                                        className="rounded-full text-xs text-white bg-secondary py-1 px-3"
                                    >
                                        {CATEGORIES.find(item => item.value === niche)?.label ? CATEGORIES.find(item => item.value === niche)?.label : niche}
                                    </span>
                                ))}
                                {data?.niches?.length >2 && (
                                    <span className="rounded-full text-xs text-white bg-secondary py-1 px-3">
                                        +{data?.niches?.length - 2}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>


                </div>
                
               
            </div>
    );
}

export default Card;
